module.exports = __webpack_public_path__ + "static/icons/icon-ski-hire--black-2007013e55011370bedc9e7af750fa79.svg";